<a class="d-flex align-items-start" (click)="updateActiveLang(getLang() === 'en_GB' ? 'da_DK' : 'en_GB', $event)" href="#">
  <!--<span class="lang-text d-none d-sm-flex">{{getLang() !== 'en_GB' ? 'English' : 'Danish'}}</span>-->
  <img style="min-width: 25px;" [src]="'../../../assets/icons/flags/' + (getLang() === 'en_GB' ? 'en' : 'dk') + '-flag.svg'" alt="gb" class="w25 lang-switcher-icon">
</a>
